import { render, staticRenderFns } from "./creating-exercise-programs.vue?vue&type=template&id=29894f58&"
import script from "./creating-exercise-programs.vue?vue&type=script&lang=js&"
export * from "./creating-exercise-programs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports